
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aiCGZd9xa52_45R2lLolca5rbuA2QFLsTxkZ4qyrM3fk92sMeta } from "/Users/ress/dev/foldwrap/frontend/pages/ai.vue?macro=true";
import { default as clicki4G9x8OVGIY70KwRQfFk62NP2QqIvKxByPj0AEr_xzYMeta } from "/Users/ress/dev/foldwrap/frontend/pages/click.vue?macro=true";
import { default as indexXjUJi2oPrZpSmd75npcItmfIZZ6UensiCoz3ufjPB8IMeta } from "/Users/ress/dev/foldwrap/frontend/pages/index.vue?macro=true";
import { default as contactmTi3mssr9LQfdjyWgPtJruZr_45kBfGFSJWcFw_7G90BIMeta } from "/Users/ress/dev/foldwrap/frontend/pages/contact.vue?macro=true";
import { default as log_45ahjCs8umNj7VLR5RKqSMWTOSLL1kA_5UhUbCeFxW_gMeta } from "/Users/ress/dev/foldwrap/frontend/pages/dev/log.vue?macro=true";
import { default as pricingUdGcKrNs22srpWas65pWNoeb1R_45Ym9T5Kz0w_458slvNgMeta } from "/Users/ress/dev/foldwrap/frontend/pages/pricing.vue?macro=true";
import { default as changelogfW71NuFdzOa0Ao_45CWkzrCTFAvDZjJWLOrapQm56XYdwMeta } from "/Users/ress/dev/foldwrap/frontend/pages/changelog.vue?macro=true";
import { default as index3huHEZzmstRXGQKB9ktZEg_45sHSqA6RRrRjUUUrKdJNcMeta } from "/Users/ress/dev/foldwrap/frontend/pages/dev/index.vue?macro=true";
import { default as usersUrBsnYhmiHqY94FW2tn51ihpJE5FBZLhG_45EwoTI1WxsMeta } from "/Users/ress/dev/foldwrap/frontend/pages/dev/users.vue?macro=true";
import { default as indexhNOrGzgc8q6NAE5b3uKMt3dUdsl84gJLvjJ_PPVXKMcMeta } from "/Users/ress/dev/foldwrap/frontend/pages/blog/index.vue?macro=true";
import { default as indexsCVpkvjnsNveDhwuA3dneHD_gsQhA4nhFWtmKEzoOjgMeta } from "/Users/ress/dev/foldwrap/frontend/pages/docs/index.vue?macro=true";
import { default as fontsSVT_45ipYB7Q0sEH3TQd6wj2F2h8UX0PQyM9sDlPUQx5kMeta } from "/Users/ress/dev/foldwrap/frontend/pages/user/fonts.vue?macro=true";
import { default as loginnqXV9RNaQJjMbRccGWWLJ0IOv2Ye6IZVXxJrQ0dHs0cMeta } from "/Users/ress/dev/foldwrap/frontend/pages/user/login.vue?macro=true";
import { default as _91slug_93SSX7h8Qz9v8b3D7s2T5z0ZPxCPSGsZr4dHy6XDe7px0Meta } from "/Users/ress/dev/foldwrap/frontend/pages/blog/[slug].vue?macro=true";
import { default as imitateMm1nNM6oLXNlqOuFWHxNEHGr4ae4o2lFVO15Spf1_IwMeta } from "/Users/ress/dev/foldwrap/frontend/pages/dev/imitate.vue?macro=true";
import { default as _91slug_93G6Gxvh0xKFbwFo0xGSe_PtIqDdZ2gatSNTynYM6Lu7MMeta } from "/Users/ress/dev/foldwrap/frontend/pages/docs/[slug].vue?macro=true";
import { default as _91slug_93etxOoo1r2_454IOtiOX_45_45NxCddBDlJPPKO1V2pTrMebswMeta } from "/Users/ress/dev/foldwrap/frontend/pages/page/[slug].vue?macro=true";
import { default as signupT1iHX3fg7CemSLitvBvvhJKeMlGmo9_45_45uf_45V5MHBK88Meta } from "/Users/ress/dev/foldwrap/frontend/pages/user/signup.vue?macro=true";
import { default as figma_pluginr_kA8A_45JHxM4qiO0r_45lFvJPRRuy2AGs3gWvMk6jt5FIMeta } from "/Users/ress/dev/foldwrap/frontend/pages/figma_plugin.vue?macro=true";
import { default as accountiBCP9c9PbrryaTUvHWqYtu7YsFZdHIFy5H8CIBCWV8gMeta } from "/Users/ress/dev/foldwrap/frontend/pages/user/account.vue?macro=true";
import { default as campaignsY4T4yV6YGktbihHE1_Ydxn7_45f_OW3ZOF4lB2NczQHtsMeta } from "/Users/ress/dev/foldwrap/frontend/pages/dev/campaigns.vue?macro=true";
import { default as creativesvPcf2Esi8NgdeNpeQdss47nIdbqzpsZHWvWZ5NgMfRYMeta } from "/Users/ress/dev/foldwrap/frontend/pages/dev/creatives.vue?macro=true";
import { default as banner_productionUVspKERR0laQ5k8tg_LCmbjV1nBUg5_k9x0ZreXpwfYMeta } from "/Users/ress/dev/foldwrap/frontend/pages/banner_production.vue?macro=true";
import { default as boxes_46clientGaR_45g_45WtX7Q3KyOSDS5IKzYAuhBnHCwoCZ_x5GEIG68Meta } from "/Users/ress/dev/foldwrap/frontend/pages/next/boxes.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/Users/ress/dev/foldwrap/frontend/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91_46_46_46slug_93qeKeOJW3HPVYDg4bVkU9YMCsvLaUL_45Rd7uognDYhXF4Meta } from "/Users/ress/dev/foldwrap/frontend/pages/delivery/[...slug].vue?macro=true";
import { default as _91id_93_46clientHQpwb_45kzc0FxU1vLZSSyUVhOaeUQeMmLilimF8_wrmMMeta } from "/Users/ress/dev/foldwrap/frontend/pages/editor/[id].client.vue?macro=true";
import { default as _91id_93_46client_45v1SqlF_0yQGM7_NT5P7JiKh_45O5cXaaygSTxMXcE40gMeta } from "/Users/ress/dev/foldwrap/frontend/pages/review/[id].client.vue?macro=true";
import { default as in_45housei5RM29QR232OwLgqzDkd1roLDIEcUawSTPxszpFZRDEMeta } from "/Users/ress/dev/foldwrap/frontend/pages/solutions/in-house.vue?macro=true";
import { default as gif_45exportvCKlIGq4CgCeZnE4k7o8VZCR5BnjUKGpjyExkxKneJwMeta } from "/Users/ress/dev/foldwrap/frontend/pages/features/gif-export.vue?macro=true";
import { default as password_resetevBJN_45N8PXQoVzRir5u1vE0O5cv7KiTF6a8eQhRv2_454Meta } from "/Users/ress/dev/foldwrap/frontend/pages/user/password_reset.vue?macro=true";
import { default as indexo_5VI8PkWbn22rmu2oFmxfw3XcRzb_458vJQdYJScNUCMMeta } from "/Users/ress/dev/foldwrap/frontend/pages/user/campaigns/index.vue?macro=true";
import { default as indexAAQCYsprK0C2o7JxUwesP1Cg0gd0DIKul6kwyEJDItEMeta } from "/Users/ress/dev/foldwrap/frontend/pages/user/creatives/index.vue?macro=true";
import { default as video_45exportw5U0_45muLnR5YUIiM01nzAz8NZyg_45KYtXqzz75UF1YYcMeta } from "/Users/ress/dev/foldwrap/frontend/pages/features/video-export.vue?macro=true";
import { default as freelancersYJE8emsvi4Gyf_shqmqnbP02IcaBwJCoU33R5_45UKUAIMeta } from "/Users/ress/dev/foldwrap/frontend/pages/solutions/freelancers.vue?macro=true";
import { default as video_render_tasksHT9uV3PTftDcNp4dMt7Ehjxs7ULTA1l6UvLzdgqaeKoMeta } from "/Users/ress/dev/foldwrap/frontend/pages/dev/video_render_tasks.vue?macro=true";
import { default as _91_46_46_46id_93BD5rG_45yfjzokC86X5Z3RWowf3Jv06DMhkimuvdk_6DMMeta } from "/Users/ress/dev/foldwrap/frontend/pages/dev/user_details/[...id].vue?macro=true";
import { default as scale_45with_45datapuvns8ZJGz4UFZQPa1r5erxEAL_45rD2iHA8nekLdj1_45sMeta } from "/Users/ress/dev/foldwrap/frontend/pages/features/scale-with-data.vue?macro=true";
import { default as _91_46_46_46slug_93vYPGDo0QcNrYkyuQPsQOzEtRjUAPs58SYcT4ed8okk0Meta } from "/Users/ress/dev/foldwrap/frontend/pages/user/campaigns/[...slug].vue?macro=true";
import { default as html5_45banner_45adsVZkOOeOWbDPJ_45fHT09Do3BTK_456Y_45M8h5cdrrB0YwrecMeta } from "/Users/ress/dev/foldwrap/frontend/pages/features/html5-banner-ads.vue?macro=true";
import { default as digital_45agenciesz9v3RfvVK7oerrkp_gFonuEk5D5tmlMKz_7XVhiH0pYMeta } from "/Users/ress/dev/foldwrap/frontend/pages/solutions/digital-agencies.vue?macro=true";
import { default as index11Q4vcAx6LhEl6b8jDY8QDw8c5B7SCstGxbSHMXrqjkMeta } from "/Users/ress/dev/foldwrap/frontend/pages/tools/markdown-slides/index.vue?macro=true";
import { default as automatic_45animationjqqZaNS9jxanRVzPh73qh2n1Fzq5V_45YGRFhhaydPNXkMeta } from "/Users/ress/dev/foldwrap/frontend/pages/features/automatic-animation.vue?macro=true";
import { default as side_45by_45side_45reviewZeMp7m1xFewIMI5l_eNdRiyMTQ0_l6yJD3a_45EuRX1BYMeta } from "/Users/ress/dev/foldwrap/frontend/pages/features/side-by-side-review.vue?macro=true";
import { default as adobe_45animateYJJC9sDN_zEY0T6jdMIWdI7uL_bmlFGlngXtlLrlYOwMeta } from "/Users/ress/dev/foldwrap/frontend/pages/alternatives-to/adobe-animate.vue?macro=true";
import { default as resize_45banners_45with_45aiwAmOIkunpUhM_45_25T0YkbpVTY5JyN_45hmPxf32TO4ywgMeta } from "/Users/ress/dev/foldwrap/frontend/pages/features/resize-banners-with-ai.vue?macro=true";
import { default as google_45web_45designerV3I3JUSeAAxgP_ERNYQks9lUK68qFX9HQwzA0NpRD2YMeta } from "/Users/ress/dev/foldwrap/frontend/pages/alternatives-to/google-web-designer.vue?macro=true";
import { default as component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta } from "/Users/ress/dev/foldwrap/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ } from "/Users/ress/dev/foldwrap/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "ai",
    path: "/ai",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/ai.vue")
  },
  {
    name: "click",
    path: "/click",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/click.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/contact.vue")
  },
  {
    name: "dev-log",
    path: "/dev/log",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/dev/log.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/pricing.vue")
  },
  {
    name: "changelog",
    path: "/changelog",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/changelog.vue")
  },
  {
    name: "dev",
    path: "/dev",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/dev/index.vue")
  },
  {
    name: "dev-users",
    path: "/dev/users",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/dev/users.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/blog/index.vue")
  },
  {
    name: "docs",
    path: "/docs",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/docs/index.vue")
  },
  {
    name: "user-fonts",
    path: "/user/fonts",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/user/fonts.vue")
  },
  {
    name: "user-login",
    path: "/user/login",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/user/login.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/blog/[slug].vue")
  },
  {
    name: "dev-imitate",
    path: "/dev/imitate",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/dev/imitate.vue")
  },
  {
    name: "docs-slug",
    path: "/docs/:slug()",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/docs/[slug].vue")
  },
  {
    name: "page-slug",
    path: "/page/:slug()",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/page/[slug].vue")
  },
  {
    name: "user-signup",
    path: "/user/signup",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/user/signup.vue")
  },
  {
    name: "figma_plugin",
    path: "/figma_plugin",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/figma_plugin.vue")
  },
  {
    name: "user-account",
    path: "/user/account",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/user/account.vue")
  },
  {
    name: "dev-campaigns",
    path: "/dev/campaigns",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/dev/campaigns.vue")
  },
  {
    name: "dev-creatives",
    path: "/dev/creatives",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/dev/creatives.vue")
  },
  {
    name: "banner_production",
    path: "/banner_production",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/banner_production.vue")
  },
  {
    name: "next-boxes",
    path: "/next/boxes",
    component: () => createClientPage(() => import("/Users/ress/dev/foldwrap/frontend/pages/next/boxes.client.vue"))
  },
  {
    name: "delivery-slug",
    path: "/delivery/:slug(.*)*",
    meta: _91_46_46_46slug_93qeKeOJW3HPVYDg4bVkU9YMCsvLaUL_45Rd7uognDYhXF4Meta || {},
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/delivery/[...slug].vue")
  },
  {
    name: "editor-id",
    path: "/editor/:id()",
    meta: _91id_93_46clientHQpwb_45kzc0FxU1vLZSSyUVhOaeUQeMmLilimF8_wrmMMeta || {},
    component: () => createClientPage(() => import("/Users/ress/dev/foldwrap/frontend/pages/editor/[id].client.vue"))
  },
  {
    name: "review-id",
    path: "/review/:id()",
    meta: _91id_93_46client_45v1SqlF_0yQGM7_NT5P7JiKh_45O5cXaaygSTxMXcE40gMeta || {},
    component: () => createClientPage(() => import("/Users/ress/dev/foldwrap/frontend/pages/review/[id].client.vue"))
  },
  {
    name: "solutions-in-house",
    path: "/solutions/in-house",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/solutions/in-house.vue")
  },
  {
    name: "features-gif-export",
    path: "/features/gif-export",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/features/gif-export.vue")
  },
  {
    name: "user-password_reset",
    path: "/user/password_reset",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/user/password_reset.vue")
  },
  {
    name: "user-campaigns",
    path: "/user/campaigns",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/user/campaigns/index.vue")
  },
  {
    name: "user-creatives",
    path: "/user/creatives",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/user/creatives/index.vue")
  },
  {
    name: "features-video-export",
    path: "/features/video-export",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/features/video-export.vue")
  },
  {
    name: "solutions-freelancers",
    path: "/solutions/freelancers",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/solutions/freelancers.vue")
  },
  {
    name: "dev-video_render_tasks",
    path: "/dev/video_render_tasks",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/dev/video_render_tasks.vue")
  },
  {
    name: "dev-user_details-id",
    path: "/dev/user_details/:id(.*)*",
    meta: {"middleware":["auth"]},
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/dev/user_details/[...id].vue")
  },
  {
    name: "features-scale-with-data",
    path: "/features/scale-with-data",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/features/scale-with-data.vue")
  },
  {
    name: "user-campaigns-slug",
    path: "/user/campaigns/:slug(.*)*",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/user/campaigns/[...slug].vue")
  },
  {
    name: "features-html5-banner-ads",
    path: "/features/html5-banner-ads",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/features/html5-banner-ads.vue")
  },
  {
    name: "solutions-digital-agencies",
    path: "/solutions/digital-agencies",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/solutions/digital-agencies.vue")
  },
  {
    name: "tools-markdown-slides",
    path: "/tools/markdown-slides",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/tools/markdown-slides/index.vue")
  },
  {
    name: "features-automatic-animation",
    path: "/features/automatic-animation",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/features/automatic-animation.vue")
  },
  {
    name: "features-side-by-side-review",
    path: "/features/side-by-side-review",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/features/side-by-side-review.vue")
  },
  {
    name: "alternatives-to-adobe-animate",
    path: "/alternatives-to/adobe-animate",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/alternatives-to/adobe-animate.vue")
  },
  {
    name: "features-resize-banners-with-ai",
    path: "/features/resize-banners-with-ai",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/features/resize-banners-with-ai.vue")
  },
  {
    name: "alternatives-to-google-web-designer",
    path: "/alternatives-to/google-web-designer",
    component: () => import("/Users/ress/dev/foldwrap/frontend/pages/alternatives-to/google-web-designer.vue")
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/convert_figma",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/delivery",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/page/click-correct",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  },
  {
    name: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQMeta?.name,
    path: "/docs/introduction",
    component: component_45stubv4AEjcXjAa3j24IMdlqHkZq5GigtZsvGqUYDRcjV9uQ
  }
]